import App from '../App';
import Store from '../store/index.js';
import VueRouter from 'vue-router';
import { getItemById } from '@/utils/helper.js';
import { getQueryString } from '@/utils/tools.js';

const routes = [{
        path: '/login',
        component: () =>
            import ( /* webpackChunkName: "login" */ '@/pages/Auth/loginPage'),
        hidden: true
    },
    {
        path: '/',
        component: App,
        children: [{
                path: '/',
                redirect: 'welcome',
            },
            {
                path: '/welcome',
                component: () =>
                    import ( /* webpackChunkName: "welcomePage" */ '@/pages/others/welcome.vue')
            },
            {
                // 公共模块
                path: '/public',
                component: () =>
                    import ( /* webpackChunkName: "baseComps" */ '@/pages/others/middleRouteVM.vue'),
                children: [
                    {
                        path: 'uploadImage',
                        component: () =>
                            import ( /* webpackChunkName: "uploadManage" */ '@/pages/others/uploadManage.vue')
                    },
                ]
            },
            {
                // 基础模块
                path: '/base_comp',
                component: () =>
                    import ( /* webpackChunkName: "baseComps" */ '@/pages/others/middleRouteVM.vue'),
                children: [
                    {
                        path: 'editorBase',
                        component: () =>
                            import ( /* webpackChunkName: "baseComps" */ '@/pages/CompManage/editorBaseManage.vue')
                    },
                    {
                        path: 'channelGroups',
                        component: () =>
                            import ( /* webpackChunkName: "baseComps" */ '@/pages/CompManage/channelGroupsManage.vue')
                    },
                    {
                        path: 'imgItemManage',
                        component: () =>
                            import ( /* webpackChunkName: "baseComps" */ '@/pages/CompManage/imgItemManage.vue')
                    }
                ]
            },
            {
                // 活动页面模板
                path: '/acttemp',
                component: () =>
                    import ( /* webpackChunkName: "acttemp" */ '@/pages/others/middleRouteVM.vue'),
                children: [{
                        path: '/',
                        redirect: 'actTempList'
                    },
                    {
                        path: 'actTempList',
                        component: () =>
                            import ( /* webpackChunkName: "acttemp" */ '@/pages/ActTemp/ActTempList.vue')
                    },
                    {
                        path: 'actTempList/edit/:ID?',
                        component: () =>
                            import ( /* webpackChunkName: "acttemp" */ '@/pages/ActTemp/editPage.vue')
                    },
                    {
                        path: 'recycle',
                        component: () =>
                            import ( /* webpackChunkName: "acttemp" */ '@/pages/ActTemp/RecycleList.vue')
                    }
                ]
            },
            {
                path: '/auth',
                component: () =>
                    import ( /* webpackChunkName: "authComp" */ '@/pages/others/middleRouteVM.vue'),
                children: [{
                        path: '/',
                        redirect: 'userManage'
                    },
                    {
                        path: 'userManage',
                        component: () =>
                            import ( /* webpackChunkName: "authComp" */ '@/pages/Auth/userManage.vue')
                    },
                    {
                        path: 'roleManage',
                        component: () =>
                            import ( /* webpackChunkName: "authComp" */ '@/pages/Auth/roleManage.vue')
                    },
                    {
                        path: 'authPointList',
                        component: () =>
                            import ( /* webpackChunkName: "authComp" */ '@/pages/Auth/authPointList.vue')
                    },
                    {
                        path: 'editRole/:ID?',
                        component: () =>
                            import ( /* webpackChunkName: "authComp" */ '@/pages/Auth/editRole.vue')
                    },
                    {
                        path: 'actionLog',
                        component: () =>
                            import ( /* webpackChunkName: "authComp" */ '@/pages/Auth/actionLogList.vue')
                    },
                ]
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: __dirname,
    routes
});

// 设置初始菜单权限
function initMenuAuth(to) {
    let tmpArr = to.path ? to.path.split('/') : [];
    let menuPath = tmpArr.length > 2 ? `/${tmpArr[1]}/${tmpArr[2]}` : '';
    let menuAction = null;
    if (tmpArr[2]) {
        let tmpObj = getItemById(Store.state.userInfo.auth_points, tmpArr[2], 'action');
        menuAction = tmpObj ? tmpObj.action : null;
    }
    // 路由与菜单权限映射
    Store.commit('UPDATE_CUR_MENU', {
        action: menuAction,
        menuPath: menuPath
    });
}
function initPDMSdk(info) {
    if (
        !/sandbox|localhost|127\.0.0.1/i.test(location.hostname)
        && window.platformData
    ) {
        window.platformData.init({
            platform_user_id: info.dingding_unionid,
            platform_id: "158095595600000070"
        })
    }
}
router.beforeEach((to, from, next) => {
    if (to.path.search('loading') !== -1 || to.path.search('reloadPage') !== -1 || to.path.search('login') !== -1) {
        next();
    } else if (
        Store.state.userInfo.user_id === 0 ||
        Store.state.curAction === null
    ) {
        Store.dispatch('getCurUser').then(() => {
            if (getQueryString('access_token')) {
                window.location.href = `${window.location.origin}${window.location.pathname}`;
            }
            initMenuAuth(to);
            initPDMSdk(Store.state.userInfo);
            next();
        });
    } else if (getQueryString('access_token')) {
        window.location.href = `${window.location.origin}${window.location.pathname}`;
    }
    else {
        initMenuAuth(to);
        next();
    }

});

router.afterEach((to, from, next) => {
    if (
        !/sandbox|localhost|127\.0.0.1/i.test(location.hostname)
        && window.platformData
    ) {
        window.platformData.emitHashEvent();
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/router.js